import { useEffect, useState } from 'react'
import { RootState, useSelector } from 'redux/store'
import { UIContractState as Guarantee } from '../@types/UIContractState'

// Helpers

export const getTaskDate = (guarantee: Guarantee): string | undefined =>
  guarantee?.TriContractState?.eventTimestamp?.substring(
    0,
    guarantee?.TriContractState?.eventTimestamp.length - 5
  )

export const getTaskId = (guarantee: Guarantee) =>
  guarantee?.TriContractState?.contractIdentifier

const sortTasksByDate = (task1: Guarantee, task2: Guarantee): number => {
  const date1 = getTaskDate(task1);
  const date2 = getTaskDate(task2);
  if (!date1 || !date2) {
    return !date1 && !date2 ? 0 : !date1 ? 1 : -1;
  }

  // Convert to Date objects and compare
  return new Date(date2).getTime() - new Date(date1).getTime();
}

// ----------------------------------------------------------------------

export const useMyTasks = () => {
  const { allGuarantees, isLoading } = useSelector((state: RootState) => state?.allGuarantees)
  const [myTasks, setMyTasks] = useState<any[]>([])

  useEffect(() => {
    let filteredTasks: any[] = []
    allGuarantees?.forEach((gx: any) => {
      const { businessUnitActionContext } = gx
      businessUnitActionContext?.[0]?.availableActions?.forEach((av) => {
        av.action !== 'EXECUTE' &&
          ['APPROVE', 'PROPOSE'].includes(av.action) &&
          av.workflowTaskLabel === 'pending' &&
          filteredTasks.push(gx)
        av.action === 'EXECUTE' && av.workflowTaskLabel === 'pending' && filteredTasks.push(gx)
      })
    })
    filteredTasks.sort((a, b) => sortTasksByDate(a, b))
    setMyTasks(filteredTasks)
  }, [allGuarantees])

  return { myTasks, isLoading }
}
